module.exports = __webpack_public_path__ + "static/media/photo75.db72da61.jpg";